import { MonetizationOn } from "@mui/icons-material";
import { Box, CircularProgress, Typography } from "@mui/material";
import { colors } from "../../../theme/muiColors";
import { widgetSmallHeight } from "../../../utils";
import { getBenefitErrorMessage, isBenefitForbiddenError, WidgetBenefitBlockedState } from "../../common/WidgetBenefitBlockedState";
import { WidgetComponentCharts } from "../../common/WidgetComponentCharts";
import { useGetInvoiceMetrics } from "./hooks/useGetInvoiceMetrics";
import { InvoiceActionsMenu } from "./InvoiceActionsMenu";
import { MetricsContent } from "./InvoiceWidget";

export const InvoiceRevenueWidget = () => {
  const { metrics, isLoading, isError, error } = useGetInvoiceMetrics();

  const isForbidden = isBenefitForbiddenError(error);
  const errorMessage = isForbidden ? getBenefitErrorMessage(error, "Your current plan does not include invoice metrics.") : "Error loading metrics";

  return (
    <WidgetComponentCharts
      sxProp={{ height: widgetSmallHeight }}
      swapyName={"Invoice-revenue"}
      title={"Invoices"}
      icon={<MonetizationOn />}
      actions={<InvoiceActionsMenu />}
      description={
        isLoading
          ? "Loading metrics..."
          : isForbidden
            ? "Manage and optimize your invoices efficiently."
            : isError || !metrics
              ? errorMessage
              : `${metrics.paidInvoices} paid • ${metrics.pendingInvoices} pending`
      }
      data={
        <Box sx={{ width: "100%", flex: 1, minHeight: 0, display: "flex", flexDirection: "column", height: isForbidden ? "300px" : "auto" }}>
          {isLoading ? (
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
              <CircularProgress size={24} />
            </Box>
          ) : isForbidden ? (
            <WidgetBenefitBlockedState title="Invoices Metrics Locked" message={errorMessage} />
          ) : isError || !metrics ? (
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%", px: 2 }}>
              <Typography sx={{ color: colors.grey[400], textAlign: "center", fontSize: "0.85rem" }}>{errorMessage}</Typography>
            </Box>
          ) : (
            <MetricsContent metrics={metrics} />
          )}
        </Box>
      }
      dataLabel={undefined}
      dataSize={undefined}
      sideData={undefined}
      sideDataLabel={undefined}
      sideDataSize={undefined}
      children={undefined}
      refResizeObserver={undefined}
      bottomLeft={undefined}
      bottomRight={undefined}
    />
  );
};
